import React from 'react';

import { AutoriteFourriereViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';
import { useSubmitReferentielForm } from 'hooks/referentiels/useSubmitReferentielForm';
import { useValidateReferentielForm } from 'hooks/referentiels/useValidateReferentielForm';

import { AutoriteFourriereFormValues } from '../type';
import { buildRequestDto } from '../utils';

import ModalEditionAutoriteFourriere from './ModalEditionAutoriteFourriere';

interface ModalCreateProps {
  close: () => void;
  visible: boolean;
  refreshDashboard: () => void;
}

export default function ModalCreate({
  close,
  visible,
  refreshDashboard,
}: ModalCreateProps): React.ReactElement {
  const initials: AutoriteFourriereFormValues = {};
  const { AdminFonctionnelControllerApi } = useApi();
  const { submit, inProgress } = useSubmitReferentielForm(
    refreshDashboard,
    close,
    (values: AutoriteFourriereFormValues) =>
      AdminFonctionnelControllerApi.createAutoriteFourriereUsingPOST(
        buildRequestDto(values),
      ),
  );
  const { validate } = useValidateReferentielForm(
    (
      field: AutoriteFourriereViolationDtoFormFieldEnum,
      values: AutoriteFourriereFormValues,
    ) =>
      AdminFonctionnelControllerApi.validateCreateAutoriteFourriereFieldUsingPOST(
        field,
        buildRequestDto(values),
      ),
    response => response.autoriteFourriereViolationsDto ?? [],
  );

  return (
    <ModalEditionAutoriteFourriere
      close={close}
      visible={visible}
      title="Créer autorité de fourrière"
      initials={initials}
      isSubmitting={inProgress}
      submit={submit}
      validate={validate}
    />
  );
}
